<template>
  <div class="profile">
    <div class="profile-cover-image"></div>
    <div class="profile-content">
      <div class="profile-description">
        <profile-description :user="user"></profile-description>
      </div>
      <div class="profile-data">
        <div class="profile-panels">
          <profile-panels :data="data"></profile-panels>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePanels from "@/components/Profile/ProfilePanels";
import ProfileDescription from "@/components/Profile/ProfileDescription";
import { useStore } from "vuex";
import useUserProfile from "@/composables/useUserProfile";
export default {
  components: {
    ProfilePanels,
    ProfileDescription,
  },
  setup() {
    const store = useStore();
    const { data, user } = useUserProfile(store);
    return {
      data,
      user,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profile.scss"></style>
